import React, { useState } from "react";

import "./App.css";

const quotes = [
  "If you are good at something, never do it for free.",
  "I fear not the man who has practiced 10,000 kicks once, but I fear the man who has practiced one kick 10,000 times.",
  "The only way to do great work is to love what you do.",
  "Success is not final, failure is not fatal: it is the courage to continue that counts.",
  "Don’t count the days, make the days count.",
  "Action is the foundational key to all success.",
  "Whether you think you can or you think you can’t, you’re right.",
  "The best way to predict the future is to create it.",
];

function App() {
  const [quote, setQuote] = useState(quotes[0]);

  function randomizeQuote() {
    const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
    setQuote(randomQuote);
  }

  return (
    <div className="App">
      <div className="quote-card">
        <p className="quote-text">"{quote}"</p>
        <button className="btn-random" onClick={randomizeQuote}>
          New Quote
        </button>
      </div>
    </div>
  );
}

export default App;
